<div class="picker">
  <input
    [name]="name"
    type="color"
    [(ngModel)]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onChange.emit($event)"
  />
</div>
